import { ShareWorkspaceDialog } from "@/action-dialog/dialogs/ShareWorkspaceDialog";
import type { Workspace } from "@cohesive/api-client";
import { createCallable } from "react-call";

const UNMOUNTING_DELAY_MS = 200;

export type ShareWorkspaceCallableProps = {
  workspace: Workspace;
};

export const ShareWorkspaceCallable = createCallable<
  ShareWorkspaceCallableProps,
  boolean
>(({ call, workspace }) => {
  return (
    <ShareWorkspaceDialog
      workspace={workspace}
      onClose={() => call.end(false)}
    />
  );
}, UNMOUNTING_DELAY_MS);

ShareWorkspaceCallable.displayName = "ShareWorkspaceCallable";
